import React from "react";
import BaseModal from "../BaseModal/index.tsx";
import CadastroHospital from "../../CadastroHospital/index.tsx";

const CadastroHospitalModal = ({ isOpen, onClose, onAdd }) => {
  return (
    <BaseModal isOpen={isOpen} title="Cadastro de Hospital" onClose={onClose}>
      <CadastroHospital onAdd={onAdd} />
    </BaseModal>
  );
};

export default CadastroHospitalModal;
